import { render } from "./template2.vue?vue&type=template&id=e06c5dd8"
import script from "./template2.vue?vue&type=script&lang=js"
export * from "./template2.vue?vue&type=script&lang=js"

import "./template2.vue?vue&type=style&index=0&id=e06c5dd8&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__